<section class="w3l-form-25">
  <div class="w3l-form-25">
    <BR>
   <label style="width: 250px;">   </label>
   <button type="button" id="Arabic" name="Arabic"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchArabic()">ع </button>
   <button type="button" id="English" name="English"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchEnglish()">En</button>
 </div>
 <div class="form-inner-cont">
  <div class="w3l-form-25">
      <h1>{{ 'Accounting Department Data' | translate }}</h1>
      <p>{{'Enter Patient Invoice' | translate }}</p>
      <h1 style="color: rgb(79, 79, 161);font-weight: bolder;">{{'Patient Invoice' | translate }}</h1>
  </div>
</div>

<div id="w3l-appointment">
  <div class="wrapper">
  <div class="d-grid doctor-appointment">
    <form action="#" method="post" >

        <div class="appointment-form-field">
            <label style="width: 7%;">{{ 'Serial' | translate }}</label>
            <input type="text" name="expSerial" placeholder="" required="" style="width: 15.5%;" [(ngModel)]="hedserial" (change)="retriveStockHd()">
            <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialogSerial()"></span>

            <label style="width: 35%;"></label>
            <label style="width: 5%;">{{ 'Date' | translate }}</label>
            <input type="date" name="expdate"  required="" style="width: 20%;" [(ngModel)]="heddate">
          </div>
        <div class="appointment-form-field">
          <label style="width:  7%;">{{ 'Program' | translate }}</label>
          <select id="kind" name="trkind" class="example-label"  style="width: 20%;background-color:  rgb(187, 203, 238);" [(ngModel)]= "hedprogramno" [value]="hedprogramno"  required>
              <option value="01">01</option>
              <option value="02">02</option>
              <option value="03">03</option>
              <option value="04">04</option>
              <option value="05">05</option>
              <option value="06">06</option>
              <option value="07">07</option>
              <option value="08">08</option>
              <option value="09">09</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
              <option value="13">13</option>
              <option value="14">14</option>
              <option value="15">15</option>
              <option value="16">16</option>
              <option value="17">17</option>
              <option value="18">18</option>
              <option value="19">19</option>
              <option value="20">20</option>
          </select>
          <label style="width: 35%;"></label>
          <label style="width: 5%;">{{ 'Store' | translate }}</label>
          <select id="trstore" name="trsstor" class="example-label" style="width: 30%;background-color:  rgb(187, 203, 238);" [(ngModel)]="hedstore"  >
            <option *ngFor="let cur of storesList" value="{{cur.strcode}}" >{{cur.strdesc1}}</option>
          </select>
        </div>
        <div class="appointment-form-field">
          <label style="width:  7%;">{{ customer | translate }}</label>
          <select id="kind" name="trsalute" class="example-label"  style="width: 10%;background-color:  rgb(187, 203, 238);" [(ngModel)]= "hedtax1" [value]="hedtax1"  required>
              <option value="السيـــد">السيـــد</option>
              <option value="السيــدة">السيــدة</option>
              <option value="الأستـاذ">الأستـاذ</option>
              <option value="الأستاذه">الأستاذه</option>
              <option value="الدكتــور">الدكتــور</option>
              <option value="الدكتورة">الدكتورة</option>
              <option value="الأنـــسة">الأنـــسة</option>
              <option value="الحــــاج">الحــــاج</option>
              <option value="الحـاجـه">الحـاجـه</option>
              <option value="السفيــر">السفيــر</option>
          </select>
          <input type="text" name="pacode"  required="" style="width: 10%;" [(ngModel)]="hedsup_client" (change)="RetrivePatient()" >
          <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialogPatient()"></span>
          <label id="w3l-appointment" class="appointment-form-field" style="width: 26%;background-color:  rgb(187, 203, 238);border-style: solid;border-width: .5px;border-color: slategray;">{{patientName}}</label>

          <label style="width: 2%;"></label>
          <label style="width: 7%;text-align: center;">{{ 'Room' | translate }}</label>
          <select class="example-label" id="rooms" name="rooms" required="" style="width: 30%;background-color:  rgb(187, 203, 238);" [(ngModel)]="hedroomnumber" [value]="hedroomnumber" >
            <option value="">None</option>
            <option value="{{unit.roomCode}}" *ngFor="let unit of roomsList; let i = index">{{unit.roomName}}</option>
        </select>
        </div>
        <!-- Doctor -->
        <div class="appointment-form-field">
                <label style="width: 7%;;">{{ 'Doctor' | translate }}</label>
                <input type="text" name="expdoctor" placeholder="" required="" style="width: 20%;" [(ngModel)]="heddoctor" (change)="retrivedoctors()">
                <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialogDoctor()"></span>
                <label id="w3l-appointment" class="appointment-form-field" style="width: 26%;background-color:  rgb(187, 203, 238);border-style: solid;border-width: .5px;border-color: slategray;">{{heddoctor_Name}}</label>
                <label style="width: 2%;"></label>
                <label style="width: 7%;text-align: center;">{{ 'تابع الى' | translate }}</label>
                <select class="example-label" id="refared" name="refared" required="" style="width: 30%;background-color:  rgb(187, 203, 238);" [(ngModel)]="refared" [value]="refared" >
                  <option value="COC">COC</option>
                  <option value="Privet">Privet</option>
        </select>
              </div>
        <div class="appointment-form-field" style="width: 950px;" >
                <label style="width: 7%;;">{{ 'Notes' | translate }}</label>
                <input type="text" name="notes" placeholder="" required="" style="width: 90%;" [(ngModel)]="heddescription"  >

        </div>

    </form>
  </div>
  </div>
</div>
<BR>
  <div id="w3l-appointment">
    <div class="wrapper">
    <div class="d-grid doctor-appointment">
      <form action="#" method="post" >

          <table style="width: 1050px; table-layout: fixed;">
            <thead>
                <tr>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width: 5%;height: 10%;text-align: center;font-weight: bold;">{{ 'Line' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 10%;text-align: center;font-weight: bold;">{{ 'Item Code' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:30%;height: 10%;text-align: center;font-weight: bold;">{{ 'Item Name' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:10%;height: 10%;text-align: center;font-weight: bold;">{{ 'QTY' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:10%;height: 10%;text-align: center;font-weight: bold;">{{ 'Price' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:10%;height: 10%;text-align: center;font-weight: bold;">{{ 'Value' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:20%;height: 10%;text-align: center;font-weight: bold;">{{ 'Notes' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;height: 10%;text-align: center;font-weight: bold;">{{ 'Select' | translate }}</th>
                </tr>
            </thead>
            <tbody>

              <tr *ngFor="let pro of stocktrndetList; let i = index" style="height: 50%;font-weight: bold;">
                <td data-column="Patient ID" style="height: 10%;">{{pro.detline}}</td>
                <td data-column="Patient Name"style="height: 100%;text-align: center;">{{pro.detitem}}</td>
                <td data-column="Patient Name"style="height: 10%;text-align: center;">{{pro.detitemname}}</td>
                <td data-column="Patient Name"style="height: 10%;text-align:right;">{{pro.detqty | number:'1.2-2'}}</td>
                <td data-column="Patient Name"style="height: 10%;text-align:right;">{{pro.detprice | number:'1.2-2'}}</td>
                <td data-column="Patient Name"style="height: 10%;text-align:right;">{{pro.detvalue | number:'1.2-2'}}</td>
                <td data-column="Patient Name"style="height: 10%;">{{pro.detdescription}}</td>
                <td data-column="Patient Name11"style="height: 10%;">
                    <button name="BDrug0"  style="width: 49% !important;padding-top: 5%;font-weight: bold;color: rgb(2, 96, 2);border-radius: 10%;"  required (click)="Edit_Line(pro)"><i class="fa fa-pencil" aria-hidden="true" style="font-size: larger;"></i></button>
                    <label style="width: 2%;"></label>
                    <button name="BDrug2"  style="width: 49% !important;padding-top: 5%;font-weight: bold;color: rgb(147, 0, 0);border-radius: 10%;"  required (click)="mesgDelete(pro)"><i class="fa fa-trash-o" aria-hidden="true" style="font-size: larger;"></i></button>
                  </td>
              </tr>
              <tr>
                <th  data-column="Patient ID00" style="text-align: center;font-weight: bold;background-color: rgb(185, 185, 185);"><label >{{detline}}</label></th>
                <th  name="pacoitem" data-column="Patient ID10" style="text-align: center;font-weight: bold;background-color: rgb(185, 185, 185);"><input class="appointment-form-field" type="text" name="detitem" required style="width: 100%; cursor: -webkit-grab;" [(ngModel)]="detitem"
                    (change)="RetriveItems(itemInput)"
                    (dblclick)="OpenDialogItem()"
                    #itemInput/>
                </th>
                <th  data-column="Patient ID20" style="text-align: center;font-weight: bold;background-color: rgb(185, 185, 185);color: black;"><label class="appointment-form-field" style="color: {{wk_Color}};">{{detitemname}}</label></th>
                <th  data-column="Patient ID30" style="text-align: center;font-weight: bold;background-color: rgb(185, 185, 185);color: black;"><input  class="appointment-form-field" type="number" name="detqty" style="width: 100%" [(ngModel)]="detqty" (change)="getvalue()"></th>
                <th  data-column="Patient ID40" style="text-align: center;font-weight: bold;background-color: rgb(185, 185, 185);color: black;"><input  class="appointment-form-field" type="number" name="detprice" style="width: 100%" [(ngModel)]="detprice" (change)="getvalue()"></th>
                <th  data-column="Patient ID50" style="text-align: center;font-weight: bold;background-color: rgb(185, 185, 185);color: black;"><label >{{detvalue | number:'1.2-2'}}</label></th>
                <th  data-column="Patient ID60" style="text-align: center;font-weight: bold;background-color: rgb(185, 185, 185);color: black;"><input class="appointment-form-field" type="text" name="detdescription" [(ngModel)]="detdescription"></th>
                <th  data-column="Patient ID70" style="text-align: center;font-weight: bold;background-color: rgb(185, 185, 185);color: black;">
              <button
  name="saveline"
  class="theme-button btn"
  style="width: 100%; padding-top: 5%; font-weight: bold; color: rgb(70, 70, 247);"
  required
  (click)="submitLine(itemInput)"
>
 <i class="fa fa-plus" aria-hidden="true"></i>
 {{ ' Add' | translate }}
</button>

</th>
                </tr>
            </tbody>
          </table>
      </form>
    </div>
    </div>
  </div>
  <div id="w3l-appointment">
    <div class="wrapper">
    <div class="d-grid doctor-appointment">
      <form action="#" method="post" >

          <table style="width: 1050px; table-layout: fixed;">
            <thead>

                <tr>
                    <th style="background-color:  rgb(70, 70, 247);color: white;width: 5%;height: 10%;"></th>
                    <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;height: 10%;"></th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:29%;height: 10%;font-size: 120%;font-weight: bold;">{{ 'Total' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:10%;height: 10%;"></th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:10%;height: 10%;"></th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:10%;height: 10%;font-size: 120%;font-weight: bold;text-align:right;">{{Wk_total | number:'1.2-2'}}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:20%;height: 10%;"></th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;height: 10%;"></th>
                </tr>

            </thead>
            <tbody>


            </tbody>
          </table>
      </form>
    </div>
    </div>
  </div>
<!--
      <div id="w3l-appointment"  class="wrapper d-grid doctor-appointment">
        <button type="button" class="theme-button btn" style="width: 14.5%;height: 50px;font-weight: bold;background-color: #2e57d4;color: ghostwhite;" name="new" (click)="New_Line()">{{ 'New Record' | translate }}</button>

      </div> -->
      <BR>
      <div id="w3l-appointment">
      <div class="wrapper d-grid doctor-appointment">
      <form action="#" method="post" >
        <div class="appointment-form-field">
          <label style="width: 420px;"></label>
          <label style="width: 180px;">{{ 'Discount Amount' | translate }}</label>
          <input type="number" name="heddisc1" placeholder="" required="" style="width: 120px;font-weight: bold;color: rgb(237, 16, 16);" [(ngModel)]="heddisc1" (change)="ClucDiscPer()">
        </div>
        <div class="appointment-form-field">
          <label style="width: 420px;"></label>
          <label style="width: 180px;font-weight: bold;">{{ 'Net Value' | translate }}</label>
          <label id="w3l-appointment" class="appointment-form-field" style="width: 120px;font-weight: bold;background-color:  rgb(187, 203, 238);border-style: solid;border-width: .5px;border-color: slategray;">{{Wk_Net_Value |  number:'1.2-2'}}</label>
        </div>
      </form>
    </div>
  </div>

  <BR>
  <form style="width: 100%;text-align: center;">
    <label style="width: 25%;"></label>
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px; font-weight: bold; height: 60%;" name="submit" (click)="submitInvoice()">{{ 'Submit' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px; font-weight: bold; height: 60%;" name="Delete" (click)="MesgDelete()">{{ 'Delete' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px; font-weight: bold; height: 60%;" name="New" (click)="NewData()">{{ 'New' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px; font-weight: bold; height: 60%;" name="print"(click)="ReportInvoice()">{{ 'Print' | translate }}</button>
    <a href="revenue">
      <button type="button" class="theme-button btn" style="width: 10%;height: 60px; font-weight: bold;height: 60%;" name="Back" (click)="Revenue()">{{ 'Payment' | translate }}</button>
      </a>
    <a href="AccTransactions">
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px; font-weight: bold; height: 60%;" name="Back">{{ 'Home' | translate }}</button>
    </a>
    <label style="width: 25%;"></label>
  </form>
  <BR>
    <BR>

</section>
